import React, { useCallback, useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import StatsAPI from "@/src/api/StatsAPI";

import { devicesUsedQuery } from "./dashboard.queries";
import { buildDevicesByPlatform } from "./dashboard.utils";
import RankedQueryCard from "../charts/RankedQueryCard";

import type { JSX } from "react";

import type { GetDevicesUsedResponse } from "@/src/api/StatsAPI.types";

import type { DashboardPeriodProps } from "./dashboard.types";
import type { ChartSeries, PaidFreeSeriesKey } from "../charts/charts.types";

function DevicesCard({ period }: DashboardPeriodProps): JSX.Element {
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const { t } = useTranslation("editor-analytics");

  const seriesList = useMemo(
    (): ChartSeries<PaidFreeSeriesKey>[] => [
      {
        key: "paid",
        label: t("charts.series.paid"),
        color: "var(--chart-1)",
      },
      {
        key: "free",
        label: t("charts.series.free"),
        color: "var(--chart-2)",
      },
    ],
    [t],
  );
  const buildRankedList = useCallback(
    (response: GetDevicesUsedResponse | undefined) =>
      buildDevicesByPlatform(response?.data[0]?.platforms ?? {}, (platform) =>
        t(platform),
      ),
    [t],
  );
  const fetchCsv = async (): Promise<BlobPart> =>
    StatsAPI.getDevicesUsed({
      projectSlug,
      startDate: period.startDate,
      endDate: period.endDate,
      isExport: true,
    });

  return (
    <RankedQueryCard
      buildRankedList={buildRankedList}
      csvExport={{ fetchCsv, fileName: "platforms.csv" }}
      query={devicesUsedQuery(projectSlug, period)}
      seriesList={seriesList}
      title={t("dashboard.charts.devices")}
    />
  );
}

export default DevicesCard;
